import { getPrice, formatCurrencyAmount, formatToSi } from '@synergycms_core/utils/utils';

/**
 * Encapsula la lógica de formateo del componente Price y devuelve el precio como string.
 *
 * @param {number} amount
 * @param {{ currencies, currentCurrencyCode, hotelCurrencyCode, customerCountry? }} currencyContext
 * @param {{ hideDecimals?, hideSymbol?, forceHotelCurrency?, altCurrency?, useFormatToSi? }} options
 * @returns {string}
 */
export const formatPrice = (amount, { currencies, currentCurrencyCode, hotelCurrencyCode, customerCountry = 'ES' }, { hideDecimals = false, hideSymbol = false, forceHotelCurrency = false, altCurrency, useFormatToSi = false } = {}) => {
  const currentCurrency = currencies && currencies.find(c => c.get('code') === currentCurrencyCode);
  const hotelCurrency = currencies && currencies.find(c => c.get('code') === hotelCurrencyCode);

  let finalCurrency = forceHotelCurrency ? hotelCurrency : currentCurrency;
  if (!finalCurrency) return '';

  let convertedAmount = amount;
  let alternativeCurrency = false;

  if (altCurrency) {
    finalCurrency = alternativeCurrency = currencies.find(c => c.get('code') === altCurrency);
    if (!finalCurrency) {
      finalCurrency = forceHotelCurrency ? hotelCurrency : currentCurrency;
      alternativeCurrency = false;
    }
  }

  if (!forceHotelCurrency && hotelCurrency && hotelCurrency.get('code') !== currentCurrency.get('code')) {
    convertedAmount = getPrice(convertedAmount, hotelCurrency.get('ratio'), currentCurrency.get('ratio'));
  }

  if (alternativeCurrency) {
    if (alternativeCurrency.get('code') !== hotelCurrency.get('code')) {
      convertedAmount = getPrice(convertedAmount, hotelCurrency.get('ratio'), alternativeCurrency.get('ratio'));
    }
  }

  const useSymbol = finalCurrency.get('use_symbol');
  const symbolBefore = finalCurrency.get('position');
  const symbol = hideSymbol ? '' : useSymbol ? finalCurrency.get('symbol') : finalCurrency.get('code');
  const decimals = hideDecimals ? 0 : finalCurrency.get('decimals');
  const isUsingSymbol = useSymbol && !hideSymbol;

  return useFormatToSi
    ? formatToSi(convertedAmount, finalCurrency)
    : formatCurrencyAmount(currencies, currentCurrencyCode, finalCurrency, symbolBefore, customerCountry)(convertedAmount, symbol, decimals, symbolBefore, isUsingSymbol);
};
